import { render, staticRenderFns } from "./projects-charts.vue?vue&type=template&id=857917f2&scoped=true&"
import script from "./projects-charts.vue?vue&type=script&lang=js&"
export * from "./projects-charts.vue?vue&type=script&lang=js&"
import style0 from "./projects-charts.vue?vue&type=style&index=0&id=857917f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857917f2",
  null
  
)

export default component.exports